import * as cart from '@shopify/theme-cart';
import Alpine from 'alpinejs';

export const fusionAtcAdd = (event) => {
    // update button ui element
    event.target.classList.add('is-loading')
    event.target.disabled = true;


    
    const selectedVariant = Alpine.store('selectedVariant');

    cart.addItem(parseInt(selectedVariant.id), { quantity: 1 }).then(item => {
        cart.getState().then(cartState => {

            // Update alpine cart state
            fetch('/cart?view=json')
                .then(response => response.json())
                .then(data => {
                    let newCartData = JSON.parse(data)
                    cartState.total_savings = 0; // Initialize total savings to zero
                    cartState.items.forEach((item) => {
                        const variantToUpdate = newCartData.find(o => o.id === item.id);
                        if (variantToUpdate && variantToUpdate.compare_at_price !== undefined) {
                            item.compare_at_price = variantToUpdate.compare_at_price;
                            item.is_on_sale = true;
                            const savings = (item.compare_at_price - item.price) * item.quantity;
                            cartState.total_savings += savings;
                        } else {
                            item.compare_at_price = null;
                            item.is_on_sale = false;
                        }
                    });
                    console.log(cartState)
                    Alpine.store("cart").updateCartState(cartState);


                    // quick shop check - close quick shop if drawer is open
                    if (window.fusionElements.mobileQuickShopDrawer.hasAttribute("open")) {
                        setTimeout(() => {
                            window.fusionElements.mobileQuickShopDrawer.hide();
                            // update button ui element
                            event.target.classList.remove('is-loading');
                            event.target.disabled = false;
                            setTimeout(() => {
                                Alpine.nextTick(() => window.fusionElements.drawer.show())
                                Alpine.store("selectedVariant").updateActiveVariant({
                                    id: "",
                                    title: "",
                                    displayAtc: false,
                                });

                                let removeActiveElm = document.querySelector('.vselect_option--active');
                                if (typeof removeActiveElm !== 'undefined' && removeActiveElm) {
                                    removeActiveElm.classList.remove('vselect_option--active');
                                }



                            }, 350);
                        }, 1000);
                    } else {
                        // open cart drawer on next tick to ensure data quality
                        Alpine.nextTick(() => window.fusionElements.drawer.show())

                        // update button ui element
                        event.target.classList.remove('is-loading');
                        event.target.disabled = false;
                    }
                }).catch(error => console.error('Error fetching JSON:', error));
        });
    }).catch((err) => {
        console.log('crtErr', err);
        alert('Unable to add to cart')
        // update button ui element
        event.target.classList.remove('is-loading');
        event.target.disabled = false;
    })
}